import {createAction, props} from '@ngrx/store';


export class DatevWizardConfigExistsActions {

  private static readonly prefix = '[Datev Wizard Config Exists]';

  public static goToConfigDetails = createAction(
    `${this.prefix} Go to config details`,
    props<{
      exportConfigId: string,
    }>(),
  );

  public static goToClientId = createAction(
    `${this.prefix} Go to Client ID`,
    props<{
      firmenId: string;
    }>(),
  );

}
